export default class SUKUSearchbar extends HTMLElement {
  static get observedAttributes() {
    return ['active', 'query']
  }

  constructor() {
    super()

    this.className = 'bg-white absolute top-[-10px] left-0 w-full drop-shadow transition-all duration-500 ease-in-out opacity-0'

    this.containerEl = this.querySelector('[data-container]')
    this.formEl = this.querySelector('form')
    this.inputEl = this.querySelector('input')
    this.submitEl = this.querySelector('[data-submit]')
    this.closeEl = this.querySelector('[data-close]')

    // todo get product results container to reset on clear

    this.formEl.addEventListener('submit', this.handleSearch)
    this.inputEl.addEventListener('input', this.handleInput)
    this.closeEl.addEventListener('click', this.handleClear)
  }

  connectedCallback() {
    this.containerEl.classList.remove('opacity-0')
  }

  handleClear = (evt) => {
    evt.preventDefault()

    this.inputEl.value = ''
    this.inputEl.focus()
    this.setAttribute('query', '')

    const emptyResults = {
      pages: [],
      collections: [],
      articles: []
    }

    document.body.dispatchEvent(new CustomEvent('search-results', {
      detail: {
        results: emptyResults
      }
    }))

    this.handleProductSearch('')
  }

  handleSearch = async (evt) => {
    evt.preventDefault()

    const value = this.inputEl.value

    this.handleProductSearch(value)
    this.handleOtherSearch(value)
  }

  handleProductSearch = async (value) => {
    const results = this.querySelector('section[data-results]')
    
    const response = await fetch(`/search/suggest?q=${value}&resources[type]=product&resources[limit]=10&resources[options][fields]=title,body,tag,product_type,variants.title,vendor&section_id=predictive-search`)

    results.scrollTo(0, 0)

    if (response.ok) {
      const text = await response.text()

      results.innerHTML = text
    } else {
      results.innerHTML = ''
    }
  }

  handleOtherSearch = async (value) => {
    const response = await fetch(`/search/suggest.json?q=${value}&resources[type]=product,collection,page,article&resources[options][fields]=title,author,body,tag`)

    const { resources: { results } } = await response.json()

    // broadcast results to other components

    const event = new CustomEvent('search-results', {
      detail: {
        results
      }
    })

    document.body.dispatchEvent(event)
  }

  handleInput = (evt) => {
    const value = evt.target.value

    if (value.length < 3) {
      return
    }

    this.setAttribute('query', value)

    // debounce search 
    if (this.timer) {
      clearTimeout(this.timer)
    }

    this.timer = setTimeout(() => {
      this.handleProductSearch(value)
      this.handleOtherSearch(value)
    }, 300)
  }

  attributeChangedCallback(name, previous, current) {
    if (previous === current) {
      return
    }

    switch (name) {
      case 'active':
        this.active = current === 'true' ? true : false

        if (this.active) {
          this.classList.add('!top-[100%]')
          this.classList.add('!opacity-100')

          this.inputEl.focus()

        } else {
          this.classList.remove('!top-[100%]')
          this.classList.remove('!opacity-100')
        }

        break
      case 'query':
          this.query = current
         
          const activeQuery = this.query?.length > 0

          if (activeQuery) {
            this.submitEl.classList.add('hidden')
            this.closeEl.classList.remove('hidden')
          } else {
            this.submitEl.classList.remove('hidden')
            this.closeEl.classList.add('hidden')
          }
          
          break
    }
  }
}

customElements.define('suku-searchbar', SUKUSearchbar)
